/*
 *
 * PreventAttacksModal
 *
 * @version 1.0.0
 * @author GitHub Copilot
 * @since 04-Sep-2025
 */
import React from 'react'
import MerchantGenericCard from '@nexidigital/merchantgenericcard'
import MerchantModal from '@nexidigital/merchantmodal'
import Toggle from 'Hoc/ToggleComponent'
import PropTypes from 'prop-types'
import DataRow from 'Components/DataRow'
import MerchantTableBadge from '@nexidigital/merchanttablebadge'
import formattedMessage from './languageModule'
import PortalButton from '@nexidigital/portalbutton'
import { openUrl } from 'Utility/globalMethods'

const PreventAttacksModal = (props) => (
  <Toggle>
    <MerchantModal
      title={formattedMessage.modalTitle}
      customAnalyticsDescription={formattedMessage.introText}
      withoutButton
      onClose={() => props.actions.doHidePopup()}
      topBarTitle=' '
    >
      <div className='pciModalContent'>
        <MerchantGenericCard>
          <div className='pciModalContentHeader'>
            <DataRow full label={formattedMessage.protectionLabel} content={formattedMessage.protectionValue} />
            <DataRow full label={formattedMessage.difficultyLabel} content={formattedMessage.difficultyValue} />
          </div>
        </MerchantGenericCard>
        <div className='pciModalContentValidity'>
          <p className='pciModalContentValidityText'>{formattedMessage.validForLabel}</p>
          <div className='pciModalContentValidityBadges'>
            <MerchantTableBadge symbol label={formattedMessage.ecommerceLabel} status='brand' />
            <MerchantTableBadge symbol label={formattedMessage.motoLabel} status='brand' />
            <MerchantTableBadge symbol label={formattedMessage.faceToFaceLabel} status='brand' />
          </div>
        </div>
        <MerchantGenericCard>
          {formattedMessage.introText}
          <div className='pciModalContentSection'>
            <h1 className='pciModalContentSectionTitle'>
              {formattedMessage.advise1Title}
            </h1>
            <p>
              {formattedMessage.advise1Text}
              <PortalButton
                textButton
                size='small'
                label={formattedMessage.linkLabel}
                onClick={() => { openUrl('https://listings.pcisecuritystandards.org/pdfs/Small_Merchant_Questions_to_Ask_Your_Vendors.pdf', true) }}
              />
              .
            </p>
          </div>
          <div className='pciModalContentSection'>
            <h1 className='pciModalContentSectionTitle'>
              {formattedMessage.advise2Title}
            </h1>
            <p>
              {formattedMessage.advise2Text}
            </p>
          </div>
          <div className='pciModalContentSection'>
            <h1 className='pciModalContentSectionTitle'>
              {formattedMessage.advise3Title}
            </h1>
            <p>
              {formattedMessage.advise3Text}
            </p>
          </div>
          <div className='pciModalContentSection'>
            <h1 className='pciModalContentSectionTitle'>
              {formattedMessage.advise4Title}
            </h1>
            <p>
              {formattedMessage.advise4Text}
              <br />
              <br />
              {formattedMessage.advise4Text2}
              <br />
              <br />
              {formattedMessage.advise4Text3}
            </p>
          </div>
          <div className='pciModalContentSection'>
            <h1 className='pciModalContentSectionTitle'>
              {formattedMessage.advise5Title}
            </h1>
            <p>
              {formattedMessage.advise5Text}
            </p>
          </div>
        </MerchantGenericCard>
      </div>
    </MerchantModal>
  </Toggle>
)

PreventAttacksModal.propTypes = {
  actions: PropTypes.object
}

PreventAttacksModal.defaultProps = {
  action: {}
}

export default PreventAttacksModal
